import { useState, useEffect } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import useLocalStorageState from 'use-local-storage-state';
import Modal from '@/components/Modal';

export default function RetailerModal({ retailerIdProp }) {
	const [showModal, setShowModal] = useState(false);
	const [userHomeStore, setUserHomeStore] = useLocalStorageState('dutchie_retailer');
	const target = document.querySelector('.retailer-modal-root');
	const retailerId = typeof dutchie_retailer !== 'undefined' ? dutchie_retailer?.id : retailerIdProp;
	const retailerObj = dutchie.retailers.find(retailer => retailerId === retailer.id)

	useEffect(() => {
		if ( userHomeStore?.id !== retailerId ) {
			setShowModal(true);
		} else {
			setShowModal(false);
		}
	}, [userHomeStore]);

	function handleSwitch() {
		setUserHomeStore(dutchie.retailers.find(retailer => retailerId === retailer.id));
		setShowModal(false);
	}

	function handleKeyDown(event) {
		if (event.key === "Escape" && showModal) {
			setShowModal(false);
		}
	}
	document.addEventListener("keydown", handleKeyDown);

	return createPortal(
		<>
			{showModal && (
				<Modal className="location-modal">
					<div className="location-modal-content">
						<h2>Switch your Store to {retailerObj?.name}?</h2>
						<p>This page shows products specifically for {retailerObj?.name} </p>
						<div className="location-modal-buttons">
							<button className="btn-primary-outline cp-modal-close" onClick={() => setShowModal(false)}>Cancel</button>
							<button className="btn-primary" onClick={() => handleSwitch()}>Switch Store</button>
						</div>
					</div>
				</Modal>
			)}
			
		</>,
		target
	);
}